import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class FreespinRequestPayload extends RequestPayload {
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/requests/freespin-request-payload.ts